export const handleResendLink = async (
  axios,
  token,
  setProcessing,
  setContent,
  content,
  message
) => {
  try {
    setProcessing(true);
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/users/verify/resend`,
      { token }
    );
    if (response.status === 200) {
      setProcessing(false);
      setContent({
        ...content,
        status: "info",
        message: response.data.message,
      });
      return message.success(response.data.message);
    }
  } catch (error) {
    setProcessing(false);
    if (error?.response?.status === 400) {
      return message.error(error.response.data.error);
    }
    if (error?.response?.status === 404) {
      return message.error(error.response.data.error);
    }
    return message.error(error.message);
  }
};
